import type { InputHTMLAttributes, ReactNode } from "react";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  children: ReactNode;
  error?: string | null;
};

let counter = 0;
const nextId = () => `c${++counter}`;

export default function Checkbox({ children, id, error, ...rest }: Props) {
  const cid = id ?? nextId();
  const hasError = Boolean(error);
  return (
    <div
      data-field-error={hasError ? "true" : undefined}
      style={{ marginBottom: "0.85rem" }}
    >
      <label
        htmlFor={cid}
        style={{
          display: "flex",
          gap: "0.7rem",
          alignItems: "flex-start",
          cursor: "pointer",
          lineHeight: 1.5,
          color: hasError ? "var(--c-coral)" : "inherit",
        }}
      >
        <input
          id={cid}
          type="checkbox"
          aria-invalid={hasError || undefined}
          {...rest}
          style={{
            marginTop: "0.25rem",
            width: 18,
            height: 18,
            accentColor: "var(--c-coral)",
            flex: "0 0 auto",
            outline: hasError ? "2px solid var(--c-coral)" : undefined,
            outlineOffset: hasError ? "2px" : undefined,
            borderRadius: 2,
          }}
        />
        <span style={{ fontSize: "0.95rem" }}>{children}</span>
      </label>
      {hasError && (
        <div
          role="alert"
          style={{
            fontSize: "0.8rem",
            color: "var(--c-coral)",
            marginTop: "0.35rem",
            marginLeft: "1.7rem",
            fontWeight: 600,
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
}
